//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueIfBot from 'vue-if-bot/dist/vue-if-bot.es';
import { createCookie, readCookie } from '@/utils/cookie';
import { CONSENT_GRANTED_EVENT } from '@/utils/gtm';

export default {
  components: {
    VueIfBot,
  },
  data() {
    return {
      show: undefined,
      cookieName: 'cookieconsent_status',
      cookieExpiryDays: 365,
    };
  },
  computed: {
    hasExistingConsent() {
      const cookie = readCookie(this.cookieName);
      return cookie === '1' || cookie === '0';
    },
  },
  beforeMount() {
    this.show = !this.hasExistingConsent;
  },
  methods: {
    saveConsent(granted) {
      createCookie(this.cookieName, granted ? '1' : '0', this.cookieExpiryDays);

      /*
       * Advanced consent mode: the container is already on the page with
       * everything denied (see the gtm block in nuxt.config.js), so this only
       * has to flip the state. Rejecting is pushed too, not left to the
       * default, so the container stops waiting on wait_for_update.
       */
      const reachedGtag =
        typeof window !== 'undefined' && typeof window.gtag === 'function';

      if (reachedGtag) {
        const gtagConsent = granted ? 'granted' : 'denied';
        window.gtag('consent', 'update', {
          ad_storage: gtagConsent,
          analytics_storage: gtagConsent,
          ad_user_data: gtagConsent,
          ad_personalization: gtagConsent,
        });
      }

      /*
       * Triggers match events, not consent state, so the update above
       * re-evaluates nothing on its own: every tag blocked when the container
       * loaded stays blocked until the next page load, which is why accepting
       * can look like it did nothing until you refresh. This gives those tags
       * something to match in the same page view; their own consent checks
       * still decide whether they may fire.
       *
       * After the update, never before, and only when the update actually
       * landed - otherwise it wakes the triggers against a denied state and
       * they block exactly as before, looking correct while achieving nothing.
       */
      if (granted && reachedGtag) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: CONSENT_GRANTED_EVENT });
      }

      // an2.js is a third-party pixel bundle and ignores consent mode, so it is
      // still held back in code (see integrations/s3.client.js)
      if (
        granted &&
        typeof window !== 'undefined' &&
        typeof window.loadAnalyticsScript === 'function'
      ) {
        window.loadAnalyticsScript();
      }

      this.show = false;
    },
    /*
     * The choice is stored first, and the report cannot prevent it.
     *
     * $tracking is assigned from the catch-all page's onMounted, while this
     * banner renders outside <delay-hydration> in the default layout, so on a
     * first paint it can be clicked before that assignment lands. Reporting
     * first would throw on the missing service and the visitor's answer would
     * never be written - a banner that refuses to go away, and a consent
     * decision lost, because an analytics call failed.
     *
     * Ordering is otherwise free: the tracking service is ungated, so both
     * events are reported whichever way the visitor answered.
     */
    report(event) {
      this.$tracking?.trackEvent(event, { currentURL: this.$route.fullPath });
    },
    accept() {
      this.saveConsent(true);
      this.report('website.cookie-consent.accept');
    },
    reject() {
      this.saveConsent(false);
      this.report('website.cookie-consent.reject');
    },
  },
};
